import { allBPObj, allObj, unassignedObj } from '../../../constants';

// check if multiple selected user present in api user list or not.
const checkIsUserExist = (userListArray, selectedUserArray) => {
  let isUserExist = false;
  const isUserAll = selectedUserArray?.some((item) => item?.value === 'all');
  if (isUserAll) {
    isUserExist = false;
  } else {
    const filterUserList = userListArray?.filter((object) => {
      return selectedUserArray?.find((item) => item?.value === object?.value);
    });
    if (filterUserList?.length === selectedUserArray?.length) {
      isUserExist = true;
    } else {
      isUserExist = false;
    }
  }
  return isUserExist;
};

// generate string of multiple values
const generateStringOfValues = (dataArray) => {
  let tempDataString = null;
  const tempSelectedValues = [];

  if (dataArray?.length > 0) {
    const isAllUser = dataArray?.some((item) => item?.value === 'all');
    if (isAllUser) {
      tempDataString = 'all';
    } else {
      dataArray.forEach((item) => tempSelectedValues.push(item?.value));
      tempDataString = tempSelectedValues?.toString();
    }
  }
  return tempDataString;
};

// handle multi select dropdown filter events
const handleMultiSelectDropdownFilterEvents = (
  event,
  action,
  selectedValues,
  apiOptions,
) => {
  let tempSelectedValues = [];
  const userAction = action?.action;
  const value = action?.option?.value;

  if (userAction === 'select-option') {
    if (value === 'all') {
      tempSelectedValues = [{ value: 'all', label: 'All' }, ...apiOptions];
    } else {
      tempSelectedValues =
        event?.length === apiOptions?.length
          ? [{ value: 'all', label: 'All' }, ...event]
          : event;
    }
  }
  if (userAction === 'deselect-option') {
    if (value === 'all') {
      tempSelectedValues = [];
    } else {
      const optionList = selectedValues?.filter((option) => {
        return option?.value !== value && option?.value !== 'all';
      });
      tempSelectedValues = [...optionList];
    }
  }

  return tempSelectedValues;
};

// bind all marketplaces
const bindAllMarketplaces = (responseData) => {
  const tempMarketplacesList = [];

  if (responseData?.length > 0) {
    for (const item of responseData) {
      tempMarketplacesList.push({
        value: item?.name || item?.value,
        label: item?.country || item?.label,
        currency: item?.currency,
        id: item?.marketplace_id || item?.id,
      });
    }
  }

  if (tempMarketplacesList?.length > 1) {
    tempMarketplacesList.unshift({
      value: 'all',
      label: 'All Marketplaces',
      currency: 'USD',
    });
  }
  return tempMarketplacesList;
};

const getAssignedUser = (user) => {
  return {
    label: `${user?.first_name} ${user?.last_name}`,
    value: user?.id,
  };
};

// https://bbe.atlassian.net/browse/PDV-8757 - leadership dashboard improvements
// callback function for binding brand partners list from api response data
const bindBrandPartnersApiData = (responseData, dashboardType) => {
  const tempBrandPartnerList = [];
  const AdUserObj = dashboardType === 'advertising' ? unassignedObj : null;
  const bgsUserObj = dashboardType === 'bgs' ? unassignedObj : null;

  if (responseData?.length > 0) {
    for (const item of responseData) {
      tempBrandPartnerList.push({
        value: item?.id,
        label: item?.company_name,
        customerId: item?.id,
        accountType: item?.customer_account_type,
        marketplaces: bindAllMarketplaces(item?.marketplaces),
        adManager: item?.ad_manager
          ? getAssignedUser(item?.ad_manager)
          : AdUserObj,
        adTeamManager: item?.ad_team_manager
          ? getAssignedUser(item.ad_team_manager)
          : AdUserObj,
        bgs: item?.bgs ? getAssignedUser(item.bgs) : bgsUserObj,
        bgsManager: item?.bgs_manager
          ? getAssignedUser(item.bgs_manager)
          : bgsUserObj,
      });
    }
  }

  if (tempBrandPartnerList?.length > 1) {
    tempBrandPartnerList.unshift(allBPObj);
  }

  return tempBrandPartnerList;
};

// bind user list - bgs/bgs manager/ad manager/ad team manager data
const bindUserListData = (
  responseData,
  userRole,
  includeUnassignedObj = true,
) => {
  let tempUserList = [];
  let tempUserListWithAll = [];

  if (includeUnassignedObj) {
    tempUserList = [{ ...unassignedObj }];
    tempUserListWithAll = [{ ...unassignedObj }];
  }
  if (responseData?.length > 0) {
    for (const item of responseData) {
      if (userRole === 'BGS' || userRole === 'Ad Manager') {
        tempUserList.push({
          label: `${item?.first_name} ${item?.last_name}`,
          value: item?.id,
          icon: item?.documents?.[0] && Object.values(item?.documents?.[0])[0],
          managerUser:
            userRole === 'BGS' ? item.bgs_manager : item.ad_team_manager,
        });
      } else {
        tempUserList.push({
          label: `${item?.first_name} ${item?.last_name}`,
          value: item?.id,
          icon: item?.documents?.[0] && Object.values(item?.documents?.[0])[0],
        });
      }
    }
    tempUserListWithAll = tempUserList.slice();

    if (tempUserList?.length > 1) {
      tempUserListWithAll.unshift(allObj);
    }
  }

  return { userList: tempUserList, userListWithAll: tempUserListWithAll };
};

// bind seller and vendor contribution data
const bindMetricsContributionData = (responseData) => {
  const tempContributionData = [];

  if (responseData?.length > 0) {
    for (const item of responseData) {
      tempContributionData.push({
        customerId: item?.customer_id,
        customerName: item?.customer_name,
        accountType: item?.account_type,
        document: item?.document,
        adManager: item?.ad_manager,
        currentValue: item?.current,
        previousValue: item?.previous,
        change: item?.change,
        contribution: item?.contribution,
        contributionLevel: item?.contribution_bracket,
      });
    }
  }
  return tempContributionData;
};

// display vendor metrics value
const displayVendorMetricsValue = (value, prefix, suffix, decimalDigits) => {
  if (value === null || value === undefined || isNaN(Number(value))) {
    return 'N/A';
  }
  return `${prefix}${value
    .toFixed(decimalDigits)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${suffix}`;
};

export {
  bindAllMarketplaces,
  bindBrandPartnersApiData,
  bindMetricsContributionData,
  bindUserListData,
  checkIsUserExist,
  displayVendorMetricsValue,
  generateStringOfValues,
  handleMultiSelectDropdownFilterEvents,
};
